
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";

@Component({
  name: "BatchSettlement",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "分批结算" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private async watchData() {
    this.table.list = this.selectedItem?.packingListExtraCostSettlements || [];
    this.table.list.map((item: any) => {
      item.moneyTypeName = item.moneyType.desc;
      item.deductionName = item.deduction ? "扣款" : "补款";
      item.useAmount = Math.abs(item.useAmount);
    });
  }

  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };

  public tableCol = [
    {
      label: "费用类型",
      prop: "moneyTypeName",
      key: "moneyTypeName",
      show: true,
      disabled: false,
    },
    {
      label: "补扣款",
      prop: "deductionName",
      key: "deductionName",
      show: true,
      disabled: false,
    },
    {
      label: "金额",
      prop: "totalAmount",
      key: "totalAmount",
      show: true,
      disabled: false,
    },
    {
      label: "可用剩余金额",
      prop: "canUseAmount",
      key: "canUseAmount",
      show: true,
      disabled: false,
    },
    {
      label: "本次结算",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 4,
      maxProp: "canUseAmount",
      min: 0,
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
      show: true,
      disabled: false,
    },
  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async submitForm(): Promise<void> {
    let list = this.table.list.map((item: any) => {
      return {
        canUseAmount: item.canUseAmount,
        deduction: item.deduction,
        moneyType: item.moneyType,
        remark: item.remark,
        totalAmount: item.totalAmount,
        useAmount: item.useAmount,
        hqPackingListId: item.hqPackingListId,
      };
    });
    this.$emit("submit", list);
  }

  // 导出excel
  private isExporting = false;

  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol;
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.table.list);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `产品列表-${new Date()}`
    );
    this.isExporting = false;
  }
}
